import React from "react";
import {
  HOME_PAGE,
  JAVASCRIPT_PAGE,
  PYTHON_PAGE,
  CSS_PAGE,
  REACT_PAGE,
  ARTICLE_PAGE
} from "./4-redux/constants/action-types";
import Home from "./2-modules/Home";
import ReactPage from "./2-modules/ReactPage";
import PythonPage from "./2-modules/PythonPage";
import CSSPage from "./2-modules/CSSPage"
import { connect } from "react-redux";
import JavascriptPage from "./2-modules/JavascriptPage";
import Nothing from "./2-modules/Nothing";
import ArticlePage from "./ArticlePage";


function Router({ currentPage }) {
  switch (currentPage) {
    case HOME_PAGE:
      return <Home />;
    case JAVASCRIPT_PAGE:
      return <JavascriptPage />
    case PYTHON_PAGE:
      return <PythonPage />;
    case CSS_PAGE:
      return <CSSPage />;
    case REACT_PAGE:
      return <ReactPage />;
    case ARTICLE_PAGE:
      return <ArticlePage />;
    default:
      return <Nothing />;
  }
}

const select = ({ route }) => ({ currentPage: route.currentPage });

export default connect(select)(Router)
